import { SmartModalService } from 'app/core/services/smart-modal.service';
import { Observable, Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'itpx-select-type',
    templateUrl: './select-type.component.html',
    styleUrls: ['./select-type.component.css']
})
export class SelectTypeComponent {

    private selectedTemplate: string;
    private templates = [
        { key: 'solar_class_on_released_to_learner', value: 'Class released to learners' },
        { key: 'solar_class_on_released_to_instructor', value: 'Class released to instructor' }
    ];
    
    constructor(private modalService: SmartModalService) {
    }

    private onTemplateSelect(template) {
        this.selectedTemplate = template;
    }

    private onYes() {
        this.modalService.sendResult(this.selectedTemplate);
    }

    private onNo() {
        this.modalService.sendResult(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/templates/components/select-type/select-type.component.ts